const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-acceleration?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async positionStatus({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/grade/position-status`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-acceleration/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async gradeFrom({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-acceleration/gradeFrom`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async gradeTo({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-acceleration/grade/${id}/gradeTo`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async classStatus({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-acceleration/school`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  save({ rootGetters }, payload) {
    const schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.post('/api/class-acceleration', { ...payload, schoolId });
  },

  update({ rootGetters }, payload) {
    const schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.put(`/api/class-acceleration/${payload.id}`, { ...payload, schoolId });
  },

  updateStatus({ rootGetters }, payload) {
    const schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.put(`/api/class-acceleration/school`, { ...payload, schoolId });
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/class-acceleration/${payload.classAccelerationId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
